/**
 * Prefetch Links on Hover
 * Preloads pages when user hovers over internal links,
 * improving perceived page load speed.
 *
 * Features:
 * - Only activates on devices with hover capability (not touch)
 * - 65ms delay to avoid prefetching on quick mouse movements
 * - Skips external links, anchors, and special links
 * - Prevents duplicate prefetches
 */
(function() {
  // Only run on devices that support hover (not touch-only)
  if (!window.matchMedia('(hover: hover)').matches) return;

  const prefetched = new Set();
  let hoverTimer = null;

  function prefetch(url) {
    if (prefetched.has(url)) return;

    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    link.as = 'document';
    document.head.appendChild(link);
    prefetched.add(url);
  }

  function isValidLink(link) {
    const href = link.href;

    // Must have href
    if (!href) return false;

    // Skip anchor links
    if (href.includes('#') && href.split('#')[0] === window.location.href.split('#')[0]) return false;

    // Skip external links
    if (!href.startsWith(window.location.origin)) return false;

    // Skip links that open in new tab
    if (link.target === '_blank') return false;

    // Skip download links
    if (link.hasAttribute('download')) return false;

    // Skip javascript: links
    if (href.startsWith('javascript:')) return false;

    // Skip mailto: and tel: links
    if (href.startsWith('mailto:') || href.startsWith('tel:')) return false;

    // Skip cart change URLs (these are form actions, not navigations)
    if (href.includes('/cart/change')) return false;

    // Skip links with data-no-prefetch attribute
    if (link.hasAttribute('data-no-prefetch')) return false;

    return true;
  }

  document.addEventListener('mouseover', (e) => {
    const link = e.target.closest('a');
    if (!link || !isValidLink(link)) return;

    const href = link.href;

    // Clear any existing timer
    if (hoverTimer) {
      clearTimeout(hoverTimer);
    }

    // Delay prefetch by 65ms to avoid prefetching on quick mouse movements
    hoverTimer = setTimeout(() => {
      prefetch(href);
    }, 65);
  }, { passive: true });

  document.addEventListener('mouseout', (e) => {
    const link = e.target.closest('a');
    if (link && hoverTimer) {
      clearTimeout(hoverTimer);
      hoverTimer = null;
    }
  }, { passive: true });
})();
